/* global axios */
import ApiClient from './ApiClient';

class FollowUpTemplatesAPI extends ApiClient {
  constructor() {
    super('follow_up_templates', { accountScoped: true, apiVersion: 'v2' });
  }

  index(params = {}) {
    return axios.get(this.url, { params });
  }

  duplicate(id) {
    return axios.post(`${this.url}/${id}/duplicate`);
  }

  activate(id) {
    return axios.post(`${this.url}/${id}/activate`);
  }

  deactivate(id) {
    return axios.post(`${this.url}/${id}/deactivate`);
  }

  // Steps (sub-recurso)
  stepsUrl(templateId) {
    return `${this.url}/${templateId}/steps`;
  }

  listSteps(templateId) {
    return axios.get(this.stepsUrl(templateId));
  }

  createStep(templateId, payload) {
    return axios.post(this.stepsUrl(templateId), { step: payload });
  }

  updateStep(templateId, id, payload) {
    return axios.patch(`${this.stepsUrl(templateId)}/${id}`, { step: payload });
  }

  destroyStep(templateId, id) {
    return axios.delete(`${this.stepsUrl(templateId)}/${id}`);
  }

  reorderSteps(templateId, positions) {
    return axios.patch(`${this.stepsUrl(templateId)}/reorder`, { positions });
  }

  // Gera o conteúdo (payload_template) de um passo via IA (Captain).
  generateStepContent(templateId, step) {
    return axios.post(`${this.stepsUrl(templateId)}/generate_content`, { step });
  }
}

export default new FollowUpTemplatesAPI();
